module.exports = __webpack_public_path__ + "img/Ad_3.28b04ca4.jpg";